<template>

    <div class="select-month dropdown">

        <div class="mth-dropdown">
            <span id="mthname" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="btn btn-mth dropdown-toggle">
                <b>{{ getMonthLabel() }}</b>
            </span>

            <div aria-labelledby="mthname" class="dropdown-menu dropdown-grid-style">

                <div class="dropdown-header">
                    <a @click="prevYear()" :disabled="loading" class="btn-prev-year">
                        <i class="fal fa-fw fa-chevron-left"></i>
                    </a>
                    <span>
                        {{ currentYear }}
                    </span>
                    <a @click="nextYear()" :disabled="loading" class="btn-next-year">
                        <i class="fal fa-fw fa-chevron-right"></i>
                    </a>
                </div>

                <div class="grid-menu">

                    <template v-for="(item, index) in monthsList">
                        <a
                            :key="index"
                            v-if="currentYear == item.year"
                            class="dropdown-item mth-item"
                            :class="{ 'active' : month == item.month && year == item.year }"
                            @click="chooseMonth(item.year, item.month)"
                        >
                            <span>{{ item.label | shortLabel }}</span>
                            <br>

                            <i v-if="item.monthActive" class="fas"
                               :class="item.isLocked ? 'fas fa-lock text-success' : 'fa-unlock text-warning'"
                            ></i>
                            <i v-else class="fal fa-calendar-alt"></i>
                        </a>
                    </template>
                    
                </div>
                
            </div>
        </div>

        <div class="btn-arrows" v-if="showButtons">
            <a @click="moveBack()" :disabled="loading" class="btn btn-sm btn-primary text-white first btn-prev"><i class="fal fa-fw fa-chevron-left"></i></a> 
            <a @click="moveFwd()" :disabled="loading" class="btn btn-sm btn-primary text-white last btn-next"><i class="fal fa-fw fa-chevron-right"></i></a>
        </div>

    </div>

</template>

<script>
    export default {
        props: {
            'trans': {
                type: Object
            },
            'yearCount': {
                type: Number,
                default: 3
            },
            'year': {
                type: Number
            },
            'month': {
                type: Number
            },
            'availableMonths': {
                type: Array
            },
            'chooseAction': {
                type: Function
            },
            'loading': {
                type: Boolean,
                default: false
            },
            'showButtons': {
                type: Boolean,
                default: false
            }
        },
        
        data() {
            return {
                'monthsList': [], // { key: 12-2020, year: 2020, month: 12, label: "December", isLocked: true }
                'maxAvailableYear': null,
                'currentYear': parseInt(this.year),
                'currentMonth': parseInt(this.month),
                'minYearMonth': 202001
            };
        },

        created() {
            this.maxAvailableYear = moment().year() + 1;
        },
        
        mounted() {
            this.createMonthsList();
        },
        
        methods: {
            createMonthsList() {
                for(let y = 0; y < this.yearCount + 1; y++) {
                    for(let m = 1; m <= 12; m++ ) {

                        this.monthsList.push({ 
                            key: (m < 10 ? '0' : '') + m + "-" + (this.maxAvailableYear - y),
                            year: this.maxAvailableYear - y, 
                            month: m, 
                            label: this.trans[m],
                            isLocked: null
                        });

                    }
                }

                if(this.availableMonths) this.fillAdditionalItemsData();
            },

            fillAdditionalItemsData() {
                for (let a = 0; a < this.availableMonths.length; a++) {
                    for (let m = 0; m < this.monthsList.length; m++) {
                        
                        if(this.availableMonths[a].key == this.monthsList[m].key) {
                            this.monthsList[m].isLocked = this.availableMonths[a].isLocked;
                            this.monthsList[m].monthActive = this.availableMonths[a].monthActive;
                        }
                        
                    }
                }
            },
            
            moveBack() {
                if ( this.currentYear == this.maxAvailableYear - this.yearCount && this.currentMonth == 1 ) return;
                
                this.currentMonth -= 1;
                
                if(this.currentMonth < 1) {
                    this.currentMonth = 12;
                    this.currentYear -= 1;
                }
                
                this.chooseMonth(this.currentYear, this.currentMonth);
            },
            
            moveFwd() {
                if ( this.maxAvailableYear == this.currentYear && this.currentMonth == 12 ) return;
                
                this.currentMonth += 1;
                
                if(this.currentMonth > 12) {
                    this.currentMonth = 1;
                    this.currentYear += 1;
                }
                
                this.chooseMonth(this.currentYear, this.currentMonth);
            },
            
            chooseMonth(year, month) {
                year = parseInt(year);
                month = parseInt(month);
                
                this.currentYear = year;
                this.currentMonth = month;
                
                let selectedObj = (this.availableMonths ? this.availableMonths.find(x => x.key == (month<10 ? "0":"")+month+"-"+year) : null);
                
                this.chooseAction(year, month, selectedObj);

                document.querySelector('.mth-dropdown').classList.remove('open');
            },
            
            getMonthLabel() {
                return this.trans[this.currentMonth] + " " + this.currentYear;
            },

            nextYear() {
                if ( this.maxAvailableYear > this.currentYear ) this.currentYear += 1;
            },

            prevYear() {
                if ( this.currentYear > this.maxAvailableYear - this.yearCount ) this.currentYear -= 1;
            }

        },

        filters: {

            shortLabel: function (str) {
                if (!str) return '';
                return str.slice(0, 3);
            }

        }

    }
</script>


// WEBPACK FOOTER //
// resources/assets/admin/js/components/basic/DropdownMonths.vue